import React from "react"; 

// core components
import GridItem from "../../views/Grid/GridItem.js";
import GridContainer from "../../views/Grid/GridContainer.js";
import Table from "../../views/Table/Table.js";
import Card from "../../views/Card/Card.js";
import CardHeader from "../../views/Card/CardHeader.js";
import CardBody from "../../views/Card/CardBody.js";

import axios from 'axios'
import style from './styles.module.css'
import IconButton from '@material-ui/core/IconButton'
import EditRoundedIcon from '@material-ui/icons/EditRounded';
import Snackbar from '../utils/snackbar/Snackbar'
import {withRouter} from 'react-router-dom' 
import CircularProgress from '@material-ui/core/CircularProgress'
import GetAppRoundedIcon from "@material-ui/icons/GetAppRounded";
// import ReportIcon from '@material-ui/core/AssignmentTurnedIn'
import {connect} from 'react-redux' 
import TopBar from "../utils/Topbar/TopBar.js";
import {getReport} from './Report.api';
import {serverFileUrl} from '../../config/keys';
const Report = (props) => { 
  const [data,setData] = React.useState(false)
  const [filteredData,setFilteredData] = React.useState(false)
  const [searchValue,setSearchValue] = React.useState("")

  const [alert,setAlert] = React.useState(false);
  const [addModal,setAddModal] = React.useState(false);
  const [editModal,setEditModal] = React.useState(false);
  const [activeTax,setActiveTax] = React.useState(false) 

  React.useEffect(() => {
    fetchReport();
  },[]);
  const fetchReport = () => {
    setData(false);
    getReport(props.user._id)
      .then(res => {
        console.log('report response');
        console.log(res.data);
        if(res.success && res.data != undefined) {
          setData(res.data);  
          setFilteredData(res.data);
        } else {
          setFilteredData ('NO_DATA');
        }
    }).catch(err => {
      console.log(err)
    });
  }
  const isLoading = !filteredData;
  const showData = !isLoading;
  const details = [];

  
  !isLoading && filteredData != 'NO_DATA' && filteredData.forEach((val,index) => {
    details.push(
      [
        index + 1,
        val.from_date,
        val.to_date,
        val.status, 
        <React.Fragment>  
          {/* <IconButton onClick={() => {
            downloadExcel(val.file_url);
          }}> */}

            {val.status == 'Generated'?
            <a target='_blank' href={serverFileUrl+val.file_url} download>
            <GetAppRoundedIcon /></a>:''}
          {/* </IconButton> */}
        </React.Fragment>
      ]
    )
  });


  return (
    <GridContainer>
      <Snackbar open={alert} handleClose={() => setAlert(false)}/>

      <TopBar
        searchValue={searchValue} 
        onSearchChange={(value) => setSearchValue(value)}  
      />

      <GridItem xs={12} sm={12} md={12}>
        <Card>
          <CardHeader color="primary">
            <div className={style.cardHeader}>
              <h4>All Reports</h4> 

              {/* <div className={style.buttons}> 
                <Button color="secondary" variant="contained" onClick={() => setAddModal(true)}>Add Tax</Button>
              </div> */}
            </div>
          </CardHeader>
          <CardBody>
            {isLoading &&
              <div className={style.loader}>
                <CircularProgress />
              </div>
            }
            
            {showData && 
              <Table
                tableHeaderColor="primary"
                tableHead={["Sl No","From","TO","Status","Action"]}
                tableData={details}
              />}
          </CardBody>
        </Card>
      </GridItem> 
    </GridContainer>
  );
}

const mapStateToProps = state => ({
  user: state.appReducer.user,
})
export default withRouter(connect(mapStateToProps)(Report));